import React from "react";
import {
  Grid,
  Card,
  Box,
  Typography,
  Chip
} from "@mui/material";
import { Tooltip } from "@mui/material";


const HighlightsCards = ({ data = [] }) => {
  return (
    <Grid container rowSpacing={2}
      columnSpacing={{ xs: 1, sm: 1.5, md: 2 }} sx={{ mt: 0 }}>
      {data.map((item, i) => (
        <Grid item xs={12} sm={6} md={6} lg={6} xl={4} key={i} sx={{ paddingTop: "28px !important" }}>
          <Card
            sx={{
              borderRadius: "8px",
              background: "#fff",
              boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
              overflowX: "auto",
              position: "relative",
              paddingTop: "30px",
              overflow: "visible",

              /* CONNECTOR LINE */
              "&::before": {
                content: '""',
                position: "absolute",
                top: "-12px",
                left: "0px",
                width: "12px",
                height: "165px",
                border: "0.5px solid #708699", // light stroke like image
                borderRight: "none",
                borderBottom: "none",
                borderTopLeftRadius: "8px",
                zIndex: 1
              }
            }
            }
          >
            {/* TOP BLUE HEADER */}
            < Box
              sx={{
                position: "absolute",
                top: "0px",
                left: "0px",
                right: "0px",
                height: "30px",
                background: "#115F9C",
                display: "flex",
                alignItems: "center",
                px: { xs: 1, sm: 1.5, md: 2 },
                color: "#fff",
                fontSize: { xs: "12px", sm: "13px", md: "16px !important" },
                fontWeight: 200,
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px",
                borderBottomRightRadius: "8px",
                borderBottomLeftRadius: "0px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis"
              }}
            >
              {item.title}
            </Box>

            {/* CARD CONTENT */}
            <Box sx={{ overflow: "hidden" }}>
              {/* TOP LABELS */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  mb: 0,
                  width: "85%",
                  marginTop: "10px",
                  minWidth: "fit-content",
                  fontWeight: 400
                }}
              >
                <Chip
                  label={item.topLeftLabel}
                  size="small"
                  sx={{
                    background: "#115F9C",
                    color: "#fff",
                    fontSize: "8px",
                    height: "16px",
                    borderTopLeftRadius: "0px",
                    borderTopRightRadius: "8px",
                    borderBottomRightRadius: "8px",
                    borderBottomLeftRadius: "0px"
                  }}
                />

                <Chip
                  label={item.topRightLabel}
                  size="small"
                  sx={{
                    background: "#105e9b",
                    color: "#fff",
                    fontSize: "8px",
                    height: "16px",
                    borderTopLeftRadius: "0px",
                    borderTopRightRadius: "8px",
                    borderBottomRightRadius: "0px",
                    borderBottomLeftRadius: "8px"
                  }}
                />
              </Box>

              {/* TOP VALUES */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "2px",
                  width: "85%",
                  color: "rgba(17, 17, 17, 0.75)",
                  fontWeight: 200
                }}
              >
                <Typography sx={{ fontSize: "14px", marginLeft: "8px", fontWeight: 100 }}>
                  {item.topLeftValue}
                </Typography>

                <Typography sx={{ fontSize: "14px", fontWeight: 100, marginRight: "12px" }}>
                  {item.topRightValue}
                </Typography>
              </Box>

              {/* BIG TITLE */}
              <Tooltip
                title={item?.bigTitle?.length > 25 ? item.bigTitle : ""}
                arrow
                placement="top"
                disableHoverListener={item?.bigTitle?.length <= 25}
                componentsProps={{
                  tooltip: {
                    sx: {
                      maxWidth: "420px",       //increase width
                      fontSize: "14px",
                      lineHeight: 1.4,
                      whiteSpace: "normal",    //allow wrapping
                    },
                  },
                }}
              >
                <Typography
                  sx={{
                    fontSize: "32px",
                    fontWeight: '100 !important',
                    letterSpacing: "-0.07em",
                    mt: "10px",
                    mb: "10px",
                    marginLeft: "11px",
                    marginRight: "16px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "100%",
                    cursor: item?.bigTitle?.length >= 25 ? "pointer" : "default",

                  }}
                >
                  {item?.bigTitle?.length > 25
                    ? item?.bigTitle?.substring(0, 25) + "..."
                    : item?.bigTitle}
                </Typography>
              </Tooltip>

              {/* BOTTOM LABEL */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center", // 👈 key fix
                  justifyContent: "flex-start",
                  gap: "6px",
                  fontWeight: 400
                }}
              >
                <Chip
                  label={item.bottomLabel}
                  size="small"
                  sx={{
                    background: "#3087C5",
                    color: "#fff",
                    fontSize: "8px",
                    height: "16px",
                    borderTopLeftRadius: "0px",
                    borderTopRightRadius: "8px",
                    borderBottomRightRadius: "0px",
                    borderBottomLeftRadius: "8px",
                  }}
                />

                {/* BOTTOM VALUE */}
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: 200,
                    color: "rgba(17, 17, 17, 0.75)",
                    lineHeight: 1, // 👈 removes extra bottom space
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {item.bottomValue}
                </Typography>
              </Box>

            </Box>
          </Card>
        </Grid>
      ))
      }
    </Grid >
  );
};

export default HighlightsCards;
